<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M74.4855 49.9904L91.1565 40.2297C92.8763 39.2232 93.4515 37.0128 92.4478 35.2958L89.4903 30.2435C89.1294 29.626 88.3794 29.3638 87.7056 29.6063C84.7903 30.6523 81.455 29.5104 79.8339 26.7418C78.2071 23.9619 78.8555 20.4743 81.2154 18.45C81.7482 17.9932 81.8582 17.2123 81.5029 16.6061L78.7456 11.3339C78.1084 10.1159 76.6085 9.63942 75.3849 10.2653L71.1445 12.4362"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.8374 43.3423L69.3496 15.1794"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-dasharray="1.41 4.23" />
        <path
            d="M40.7793 36.3982C40.7793 36.3982 61.8034 23.7026 65.4433 21.9574"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M49.8171 46.5677L51.2522 46.7481C51.4298 46.7763 51.5651 46.703 51.6525 46.5254C51.7399 46.3477 51.7117 46.1983 51.568 46.0771L50.4374 45.0536L51.0407 43.5481C51.1028 43.3789 51.0633 43.2351 50.9223 43.1195C50.7813 43.004 50.6319 42.9899 50.4797 43.0801L49.1912 43.8329L48.0353 42.8038C47.8887 42.6825 47.7392 42.6656 47.587 42.7558C47.4347 42.8461 47.3727 42.9842 47.4094 43.1703L47.7421 44.6815L46.4395 45.4455C46.2844 45.5358 46.228 45.6683 46.2647 45.8459C46.3013 46.0235 46.4113 46.125 46.5889 46.1532L48.165 46.3844L48.5117 47.8871C48.5456 48.0732 48.6584 48.1747 48.8444 48.1916C49.0305 48.2085 49.163 48.1268 49.2363 47.952L49.8228 46.5677H49.8171Z"
            class="primary-fill" />
        <path
            d="M71.9831 33.5872L73.4182 33.7677C73.5958 33.7959 73.7311 33.7226 73.8186 33.545C73.906 33.3673 73.8778 33.2179 73.734 33.0967L72.6034 32.0732L73.2067 30.5677C73.2688 30.3985 73.2293 30.2547 73.0883 30.1391C72.9474 30.0235 72.7979 30.0094 72.6457 30.0997L71.3572 30.8524L70.2013 29.8234C70.0547 29.7021 69.9052 29.6852 69.753 29.7754C69.6007 29.8657 69.5387 30.0038 69.5754 30.1899L69.9081 31.7011L68.6055 32.4651C68.4504 32.5554 68.3941 32.6879 68.4307 32.8655C68.4674 33.0431 68.5773 33.1446 68.7549 33.1728L70.331 33.404L70.6778 34.9067C70.7116 35.0928 70.8244 35.1943 71.0104 35.2112C71.1965 35.2281 71.329 35.1464 71.4023 34.9716L71.9888 33.5872H71.9831Z"
            class="primary-fill" />
        <path
            d="M81.6523 45.9023C81.9935 46.1701 82.3374 46.4634 82.6871 46.7819C88.7121 52.2741 107.672 63.6024 104.659 73.0896C103.153 77.8318 100.362 87.7786 98.9887 98.1145"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.6797 56.9036C76.6797 56.9036 81.4726 66.4077 88.163 63.6137"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M56.1786 60.7068C53.878 64.9444 50.1282 72.5511 52.5585 73.0896C54.9465 73.6196 58.1747 75.6101 64.586 63.2274"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M52.5597 73.0868C52.5597 73.0868 49.636 83.3127 53.1941 84.229C56.2447 85.0156 57.8686 82.2582 60.2313 73.8452C60.2313 73.8452 64.59 71.8406 66.0279 68.2995"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M55.1713 84.2319C55.1713 84.2319 54.1986 87.6941 57.1166 87.5587C60.0375 87.4206 62.2366 83.2394 62.2254 75.8216C62.2254 75.8216 64.5852 74.9476 66.6856 72.4948"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M59.845 47.7038C58.9202 46.2349 59.7576 42.6008 57.6656 42.2963C55.2776 41.9467 52.1819 42.5641 52.3398 41.0642C52.4723 39.8039 54.7306 38.7861 54.7306 38.7861"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M57.0507 37.6443C57.0507 37.6443 55.2434 31.7151 56.5911 31.8561C57.9388 31.9999 63.3548 36.0062 62.5569 37.7035C61.759 39.4008 56.4671 36.7928 63.2308 33.8071C67.925 31.7349 67.457 33.012 66.6873 34.9292C66.4251 35.5861 65.802 37.4526 65.0267 39.584"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M74.487 49.9905C83.6782 46.3929 89.2521 60.1431 94.5667 68.3024C98.4687 74.2964 106.605 75.0238 105.579 65.8692C104.057 52.2911 42.6393 72.492 73.8724 118.017"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-miterlimit="10" />
        <path
            d="M71.1418 11.3085C62.1395 16.0761 32.8884 31.7463 29.9562 35.575C26.9 39.57 29.9901 46.2125 35.922 45.4005C41.4593 44.6421 45.2457 49.9651 41.4593 55.415C38.9641 59.0097 42.3502 65.8664 47.0304 64.7781C50.5518 63.9605 55.6323 60.4307 62.9768 56.7232"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-miterlimit="10" />
        <path
            d="M92.4392 73.5633C92.4392 73.5633 80.6486 74.2851 78.4833 64.8993C76.318 55.5136 72.3004 36.6942 64.5273 39.7589C56.2975 43.004 66.6926 64.671 66.6926 73.5746C66.6926 75.8554 66.5009 77.9643 66.2528 80.0253"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M30.5017 50.5092L26.6279 50.0496C26.4164 50.0242 26.2191 50.1567 26.1599 50.3597L25.5819 52.3474C25.4945 52.6519 25.7482 52.9451 26.0612 52.9L30.2423 52.3108C30.4115 52.2882 30.5525 52.167 30.6004 52.0006L30.8739 51.0618C30.95 50.8024 30.7752 50.5402 30.5074 50.5092H30.5017Z"
            class="primary-fill" />
        <path
            d="M32.0374 55.6263L28.9953 57.5181C28.8233 57.6253 28.7472 57.8339 28.812 58.0256L29.2236 59.2577C29.3167 59.5368 29.655 59.6439 29.8918 59.472L32.621 57.4927C32.7451 57.4025 32.8127 57.2559 32.7986 57.1037L32.6999 55.959C32.6718 55.6348 32.3137 55.4543 32.0374 55.6263Z"
            class="primary-fill" />
        <path
            d="M29.9939 53.9066L22.6776 55.5559C22.4661 55.6038 22.3223 55.8012 22.3392 56.0183L22.4915 57.8086C22.5169 58.0962 22.8073 58.2794 23.0751 58.1808L30.0446 55.5926C30.1828 55.5418 30.2843 55.4234 30.3181 55.2796L30.5098 54.4282C30.5803 54.1152 30.3012 53.8389 29.991 53.9066H29.9939Z"
            class="primary-fill" />
        <path
            d="M86.1533 21.4837L85.7558 20.9001C85.6543 20.7535 85.6543 20.5589 85.7558 20.4123L87.4362 17.9313C87.6025 17.686 87.9606 17.6747 88.141 17.9087L89.0037 19.0308C89.1419 19.2113 89.1193 19.4678 88.9502 19.6201L86.8046 21.5626C86.6101 21.7402 86.3028 21.7036 86.1533 21.4837Z"
            class="primary-fill" />
        <path
            d="M88.759 20.8719L92.8584 17.827C93.0868 17.6578 93.411 17.748 93.521 18.0102L94.192 19.6314C94.2906 19.8738 94.1581 20.1473 93.9044 20.2178L89.3793 22.0927C89.1847 22.1463 88.9761 22.0589 88.8802 21.8784L88.6378 21.4273C88.5363 21.2384 88.587 21.0016 88.7618 20.8719H88.759Z"
            class="primary-fill" />
        <path
            d="M87.8848 23.6264V24.4807C87.8848 24.7035 88.0511 24.8895 88.271 24.9121L93.3826 25.4844C93.6391 25.5126 93.8647 25.3124 93.8647 25.0531V23.6264C93.8647 23.3868 93.6701 23.1923 93.4305 23.1923H88.319C88.0793 23.1923 87.8848 23.3868 87.8848 23.6264Z"
            class="primary-fill" />
    </svg>
</template>
